module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/img-5-fd01a6dfa77e88fe1286f09b5c808873.png";